module.exports = __webpack_public_path__ + "img/leiji.47f05cb0.png";